{
  "name": "@aws-sdk/client-s3",
  "description": "AWS SDK for JavaScript S3 Client for Node.js, Browser and React Native",
  "version": "3.758.0",
  "scripts": {
    "build": "concurrently 'yarn:build:cjs' 'yarn:build:es' 'yarn:build:types'",
    "build:cjs": "node ../../scripts/compilation/inline client-s3",
    "build:es": "tsc -p tsconfig.es.json",
    "build:include:deps": "lerna run --scope $npm_package_name --include-dependencies build",
    "build:types": "tsc -p tsconfig.types.json",
    "build:types:downlevel": "downlevel-dts dist-types dist-types/ts3.4",
    "clean": "rimraf ./dist-* && rimraf *.tsbuildinfo",
    "extract:docs": "api-extractor run --local",
    "generate:client": "node ../../scripts/generate-clients/single-service --solo s3",
    "test": "yarn g:vitest run",
    "test:browser": "node ./test/browser-build/esbuild && yarn g:vitest run -c vitest.config.browser.ts",
    "test:browser:watch": "node ./test/browser-build/esbuild && yarn g:vitest watch -c vitest.config.browser.ts",
    "test:e2e": "yarn g:vitest run -c vitest.config.e2e.ts && yarn test:browser",
    "test:e2e:watch": "yarn g:vitest watch -c vitest.config.e2e.ts",
    "test:watch": "yarn g:vitest watch"
  },
  "main": "./dist-cjs/index.js",
  "types": "./dist-types/index.d.ts",
  "module": "./dist-es/index.js",
  "sideEffects": false,
  "dependencies": {
    "@aws-crypto/sha1-browser": "5.2.0",
    "@aws-crypto/sha256-browser": "5.2.0",
    "@aws-crypto/sha256-js": "5.2.0",
    "@aws-sdk/core": "3.758.0",
    "@aws-sdk/credential-provider-node": "3.758.0",
    "@aws-sdk/middleware-bucket-endpoint": "3.734.0",
    "@aws-sdk/middleware-expect-continue": "3.734.0",
    "@aws-sdk/middleware-flexible-checksums": "3.758.0",
    "@aws-sdk/middleware-host-header": "3.734.0",
    "@aws-sdk/middleware-location-constraint": "3.734.0",
    "@aws-sdk/middleware-logger": "3.734.0",
    "@aws-sdk/middleware-recursion-detection": "3.734.0",
    "@aws-sdk/middleware-sdk-s3": "3.758.0",
    "@aws-sdk/middleware-ssec": "3.734.0",
    "@aws-sdk/middleware-user-agent": "3.758.0",
    "@aws-sdk/region-config-resolver": "3.734.0",
    "@aws-sdk/signature-v4-multi-region": "3.758.0",
    "@aws-sdk/types": "3.734.0",
    "@aws-sdk/util-endpoints": "3.743.0",
    "@aws-sdk/util-user-agent-browser": "3.734.0",
    "@aws-sdk/util-user-agent-node": "3.758.0",
    "@aws-sdk/xml-builder": "3.734.0",
    "@smithy/config-resolver": "^4.0.1",
    "@smithy/core": "^3.1.5",
    "@smithy/eventstream-serde-browser": "^4.0.1",
    "@smithy/eventstream-serde-config-resolver": "^4.0.1",
    "@smithy/eventstream-serde-node": "^4.0.1",
    "@smithy/fetch-http-handler": "^5.0.1",
    "@smithy/hash-blob-browser": "^4.0.1",
    "@smithy/hash-node": "^4.0.1",
    "@smithy/hash-stream-node": "^4.0.1",
    "@smithy/invalid-dependency": "^4.0.1",
    "@smithy/md5-js": "^4.0.1",
    "@smithy/middleware-content-length": "^4.0.1",
    "@smithy/middleware-endpoint": "^4.0.6",
    "@smithy/middleware-retry": "^4.0.7",
    "@smithy/middleware-serde": "^4.0.2",
    "@smithy/middleware-stack": "^4.0.1",
    "@smithy/node-config-provider": "^4.0.1",
    "@smithy/node-http-handler": "^4.0.3",
    "@smithy/protocol-http": "^5.0.1",
    "@smithy/smithy-client": "^4.1.6",
    "@smithy/types": "^4.1.0",
    "@smithy/url-parser": "^4.0.1",
    "@smithy/util-base64": "^4.0.0",
    "@smithy/util-body-length-browser": "^4.0.0",
    "@smithy/util-body-length-node": "^4.0.0",
    "@smithy/util-defaults-mode-browser": "^4.0.7",
    "@smithy/util-defaults-mode-node": "^4.0.7",
    "@smithy/util-endpoints": "^3.0.1",
    "@smithy/util-middleware": "^4.0.1",
    "@smithy/util-retry": "^4.0.1",
    "@smithy/util-stream": "^4.1.2",
    "@smithy/util-utf8": "^4.0.0",
    "@smithy/util-waiter": "^4.0.2",
    "tslib": "^2.6.2"
  },
  "devDependencies": {
    "@aws-sdk/signature-v4-crt": "3.758.0",
    "@tsconfig/node18": "18.2.4",
    "@types/node": "^18.19.69",
    "concurrently": "7.0.0",
    "downlevel-dts": "0.10.1",
    "rimraf": "3.0.2",
    "typescript": "~5.2.2"
  },
  "engines": {
    "node": ">=18.0.0"
  },
  "typesVersions": {
    "<4.0": {
      "dist-types/*": [
        "dist-types/ts3.4/*"
      ]
    }
  },
  "files": [
    "dist-*/**"
  ],
  "author": {
    "name": "AWS SDK for JavaScript Team",
    "url": "https://aws.amazon.com/javascript/"
  },
  "license": "Apache-2.0",
  "browser": {
    "./dist-es/runtimeConfig": "./dist-es/runtimeConfig.browser"
  },
  "react-native": {
    "./dist-es/runtimeConfig": "./dist-es/runtimeConfig.native"
  },
  "homepage": "https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-s3",
  "repository": {
    "type": "git",
    "url": "https://github.com/aws/aws-sdk-js-v3.git",
    "directory": "clients/client-s3"
  }
}
